import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const addAdminSubscriptionSchema = Yup.object().shape({
    subscriptionname: Yup.string().required(CommonMessages.subscription_name_required),
    description: Yup.string().required(CommonMessages.description_required),
    from: Yup.string().required(CommonMessages.commission_slab_required),
    to: Yup.string().required(CommonMessages.commission_slab_required).test(
        'is-greater-than-from',
        CommonMessages.not_less_than,
        function (value) {
            const { from } = this.parent;// Check if to is less than from
            return parseInt(value) >= parseInt(from);
        }
    ),
    chargeType: Yup.string().required(CommonMessages.commission_type_required),
    charge: Yup.string().matches(/^\d{0,8}(\.\d{0,2})?$/, 'Enter amount.').required(CommonMessages.charge_required).test(
        'is-less-than-100',
        CommonMessages.percentage_limit,
        function (value) {
            const { chargeType } = this.parent;
            return chargeType !== '1' || parseFloat(value) < 100;
        }
    ),
})